<template>
  <v-main v-if="contentVisible" class="p-default-layout">
    <slot/>
  </v-main>
</template>


<script>
export default {
  computed: {
    contentVisible () {
      const isRedirectingAfterPageReload = (this.$route.path === '/' && !this.$route.name && !this.$route.matched.length)
      const isAuthenticating = this.$auth.loading || this.$redirectingFromAuth

      return !isAuthenticating && !isRedirectingAfterPageReload
    }
  }
}
</script>

